/**
 * Core module loader.
 *
 * Loads all core modules in dependency order using topological sort.
 */

import { registerModule } from './registry.js'
import { topologicalSort, validateModuleDependencies } from './definition-extractors.js'
import { CORE_MODULES } from '../../modules/index.js'
import { getLibPath, getProjectPath } from '@kernel/config/paths.js'

/**
 * Loads the backend core modules in dependency order.
 * Uses topological sort to ensure dependencies are registered first.
 *
 * Filters out modules that only apply to user projects (e.g. plugins module
 * is excluded during nexus-backend development where libPath === projectPath).
 *
 * @throws Error if circular dependencies are detected
 */
export function loadCoreModules(): void {
  const isUserProject = getLibPath() !== getProjectPath()

  const modules = isUserProject
    ? CORE_MODULES
    : CORE_MODULES.filter(m => m.name !== 'plugins')

  validateModuleDependencies(modules)
  const ordered = topologicalSort(modules)

  for (const mod of ordered) {
    registerModule(mod, { source: 'core' })
  }
}
